import { CONFIG } from '../config';

/**
 * Helper to make API requests
 * @param {string} endpoint - The API endpoint (e.g., '/bookings')
 * @param {object} options - fetch options
 * @returns {Promise<object>} - The response data
 */
export async function apiRequest(endpoint, options = {}) {
  const url = `${CONFIG.API_URL}${endpoint}`;

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  try {
    const response = await fetch(url, {
      ...options,
      headers
    });

    const data = await response.json();

    if (!response.ok) {
      const error = new Error(data.error || 'API Request Failed');
      error.data = data; // Attach data for handling specific fields (e.g. conflict)
      error.status = response.status;
      throw error;
    }

    return data;
  } catch (error) {
    // Re-throw the error to be handled by the caller
    throw error;
  }
}
